module.exports = __webpack_public_path__ + "img/27.0e69dfdd.jpg";